import React, { useState } from 'react';

import QRCode from 'qrcode.react';

import { useURLSearchParams } from '@shared/hooks/use_url_search_params';

import { InputFormGroup } from '@admin/components/fields';
import { Panel } from '@admin/components/helpers/panel';
import { useTitle } from '@admin/hooks/use_title';

export const QrCodePanel: React.FC = () => {
  const [params] = useURLSearchParams();
  const [value, setValue] = useState(() => params.get('value') ?? 'http://www.clutter.com');

  useTitle('QR Code Generator');

  return (
    <Panel>
      <Panel.Body>
        <div>
          <h1>QR Code Value: {value}</h1>
          <QRCode value={value} size={256} />
        </div>
        <div className="text-left mar-top">
          <InputFormGroup
            label="Change QR Code Value"
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
          />
        </div>
      </Panel.Body>
    </Panel>
  );
};
